// @ts-nocheck
import { MOCK } from "@/state/app-store";
import { UI } from "@/components/ui";
import { Icon } from "@/components/icons";
import { api } from "@/api/index";

const { $, $$, fmtNum, fmtMoney, fmtPercent, toast, confirmModal, hasPerm, statusBadge, trendArrow, statCard, channelChip, capabilityBadge, pageHeader, emptyState, primaryBtn, ghostBtn, stepIndicator, BUSINESS_COLORS, chartTooltip, chartXAxis, chartYAxis, chartLineSeries, chartBarSeries } = UI;

declare const echarts: any;
declare const Pages: Record<string, any>;
declare const PageHooks: { mounted?: ((path: string) => void) | null };
declare function navigate(path: string): void;
declare function getCurrentPath(): string;
declare function getCurrentPathWithQuery(): string;
declare function renderRoute(): void;

if (typeof window !== "undefined") {
  (window as any).Pages = (window as any).Pages || {};
}

const Pages = (window as any).Pages;

// ============================================================
// 功能全景（商务风版）· 仅 SDK 管理员可见
// 极简表格化布局，不再用大色块
// ============================================================

function renderFunctionGrid() {
  if (MOCK.SESSION.currentRole !== "sdk_admin") return "";

  const sections = [
    {
      title: "研发工具",
      colorBar: "bg-brand-700",
      colorText: "text-brand-700",
      items: [
        { icon: "gamepad",  title: "游戏管理", desc: "管理所有接入游戏",       path: "/dev/games",            badge: MOCK.GAMES.length + " 款" },
        { icon: "plus",     title: "创建游戏", desc: "新接入一款游戏",         path: "/dev/games/create" },
        { icon: "package",  title: "包体管理", desc: "Region × Platform 配置", path: "/dev/packages",         badge: MOCK.PACKAGES.length + " 个" },
        { icon: "plus",     title: "创建包体", desc: "为游戏添加新包体",       path: "/dev/packages/create" },
        { icon: "activity", title: "SDK 监控", desc: "调用 / 错误 / 性能",     path: "/dev/sdk-monitor",      badge: "1.2%", warn: true },
        { icon: "book",     title: "SDK 文档", desc: "集成 + API 参考",        path: "/dev/sdk-docs" },
      ],
    },
    {
      title: "运营管理",
      colorBar: "bg-ok-600",
      colorText: "text-ok-700",
      items: [
        { icon: "globe",    title: "分享落地页配置",   desc: "创建落地页资产", path: "/ops/share-landing-config" },
        { icon: "globe",    title: "已配置落地页管理", desc: "管理落地页资产", path: "/ops/configured-landing-pages", badge: MOCK.LANDING_PAGES.length + " 个" },
        { icon: "layers",   title: "模版库",           desc: "落地页预制模版",      path: "/ops/template-library", badge: MOCK.TEMPLATES.length + " 个" },
        { icon: "image",    title: "分享卡片配置",     desc: "创建分享卡片",        path: "/ops/share-card-config" },
        { icon: "image",    title: "已配置卡片管理",   desc: "管理分享卡片",        path: "/ops/configured-cards", badge: MOCK.SHARE_CONFIGS.length + " 个" },
        { icon: "calendar", title: "分享活动配置",     desc: "活动分享方案",   path: "/ops/share-config",      badge: MOCK.SHARE_CONFIGS.filter((cfg) => cfg.scope === "package_set").length + " 个" },
        { icon: "package",  title: "包体运营",       desc: "累计配置历史",       path: "/ops/package-config" },
        { icon: "send",     title: "分享管理",       desc: "实时分享流水查询",    path: "/ops/share-manager" },
        { icon: "chart",    title: "数据分析",       desc: "漏斗 / 渠道 / 路径",  path: "/ops/analytics" },
      ],
    },
    {
      title: "管理员功能",
      colorBar: "bg-warn-600",
      colorText: "text-warn-700",
      items: [
        { icon: "shield",   title: "管理员总览", desc: "平台治理总入口",       path: "/admin/overview", badge: "新版" },
        { icon: "package",  title: "SDK 发布中心", desc: "发布、推荐、废弃",     path: "/admin/platform/sdk-releases", badge: "v2.4.0" },
        { icon: "globe",    title: "渠道能力中心", desc: "Adapter / Schema",     path: "/admin/platform/channels", badge: MOCK.CHANNELS.length + " 个" },
        { icon: "database", title: "配置模型治理", desc: "Schema / 兼容性",     path: "/admin/platform/config-schema" },
        { icon: "settings", title: "平台参数", desc: "归因 / 短链 / 缓存", path: "/admin/platform/settings" },
        { icon: "globe",    title: "多语言配置", desc: "Share 语种池", path: "/admin/platform/share-languages", badge: "BCP 47" },
        { icon: "globe",    title: "区域国家配置", desc: "Global / ISO 国家", path: "/admin/platform/regions-countries", badge: "10+1" },
        { icon: "gamepad",  title: "游戏管理", desc: "跨游戏高风险治理",       path: "/admin/governance/games", badge: MOCK.GAMES.length + " 款" },
        { icon: "key",      title: "凭证与密钥", desc: "OpenAPI Key / 重置",    path: "/admin/security/credentials" },
        { icon: "users",    title: "用户与角色", desc: "授权 + 审计",          path: "/admin/security/users", badge: MOCK.USERS.length + " 人" },
        { icon: "activity", title: "平台健康", desc: "服务 / 渠道 / 数据链路", path: "/admin/platform/health" },
      ],
    },
  ];

  return `
    <div class="card mb-5">
      <div class="px-5 py-4 border-b border-ink-200 flex items-center justify-between">
        <div>
          <h3 class="text-[13px] font-semibold text-ink-900 flex items-center gap-2">
            ${Icon.zap({ size: 14, color: "#1E3A8A" })}
            功能全景
            <span class="badge bg-brand-900 text-white">SDK 管理员</span>
          </h3>
          <p class="text-[11px] text-ink-500 mt-1">您拥有平台所有功能权限 · 共 22 个核心模块</p>
        </div>
        <div class="text-[11px] text-ink-500 flex items-center gap-3">
          <span class="flex items-center gap-1.5"><span class="dot bg-brand-700"></span>研发 6</span>
          <span class="flex items-center gap-1.5"><span class="dot bg-ok-600"></span>运营 9</span>
          <span class="flex items-center gap-1.5"><span class="dot bg-warn-600"></span>管理员 11</span>
        </div>
      </div>

      <div class="divide-y divide-ink-100">
        ${sections.map(s => `
          <div class="px-5 py-4">
            <div class="flex items-center gap-2 mb-3">
              <span class="w-0.5 h-3.5 ${s.colorBar} rounded"></span>
              <span class="text-[12px] font-semibold ${s.colorText}">${s.title}</span>
              <span class="text-[10px] text-ink-400">${s.items.length} 项</span>
            </div>
            <div class="grid grid-cols-6 gap-2">
              ${s.items.map(it => `
                <a href="#${it.path}" class="group border border-ink-200 rounded-md bg-white hover:border-brand-500 hover:bg-brand-50/30 transition p-3 relative">
                  <div class="flex items-start gap-2.5">
                    <div class="w-8 h-8 rounded-md bg-ink-50 border border-ink-200 group-hover:bg-white group-hover:border-brand-300 flex items-center justify-center flex-shrink-0">
                      ${Icon[it.icon]({ size: 14, color: "#1E3A8A" })}
                    </div>
                    <div class="flex-1 min-w-0">
                      <div class="text-[12px] font-semibold text-ink-900 group-hover:text-brand-700 truncate">${it.title}</div>
                      <div class="text-[10px] text-ink-500 mt-0.5 line-clamp-1">${it.desc}</div>
                    </div>
                  </div>
                  ${it.badge ? `<span class="absolute top-2 right-2 text-[10px] font-semibold num ${it.warn ? "text-warn-700" : "text-ink-500"}">${it.badge}</span>` : ""}
                </a>
              `).join("")}
            </div>
          </div>
        `).join("")}
      </div>
    </div>
  `;
}

// __window_exports__
// Expose helpers for cross-page / inline onclick compatibility
;(window as any).renderFunctionGrid = renderFunctionGrid;
